import React from 'react';
import { motion } from 'framer-motion';

const NauticalDepthBackground: React.FC = () => {
  const draw = {
    hidden: { pathLength: 0, opacity: 0 },
    visible: (i: number) => {
      const delay = 0.5 + i * 0.3;
      return {
        pathLength: 1,
        opacity: 0.1, // Very low opacity for depth effect
        transition: {
          pathLength: { type: "spring", duration: 3, bounce: 0, delay },
          opacity: { duration: 0.01, delay }
        }
      };
    }
  };

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <motion.svg
        width="100%"
        height="100%"
        viewBox="0 0 1000 1000"
        initial="hidden"
        animate="visible"
        className="absolute inset-0"
        style={{
          transform: 'scale(1.2)', // Slightly larger to cover well
          transformOrigin: 'center center',
          filter: 'drop-shadow(0 0 5px hsla(var(--gold)/0.05))',
          stroke: 'hsl(var(--gold))', // Gold for the lines
          strokeWidth: '1',
        }}
      >
        {/* Concentric Circles */}
        {[100, 200, 300, 400].map((r, i) => (
          <motion.circle
            key={`circle-${r}`}
            cx="500"
            cy="500"
            r={r}
            fill="none"
            custom={i}
            variants={draw}
            strokeOpacity={0.05} // Even lower opacity for circles
          />
        ))}

        {/* Diagonal lines emanating from center */}
        {[0, 45, 90, 135].map((angle, i) => (
          <motion.line
            key={`line-${angle}`}
            x1="500"
            y1="500"
            x2={500 + Math.cos(angle * Math.PI / 180) * 700} // Extend beyond viewbox
            y2={500 + Math.sin(angle * Math.PI / 180) * 700}
            fill="none"
            custom={i + 4}
            variants={draw}
            strokeOpacity={0.03} // Very faint lines
          />
        ))}
        {/* Additional radial lines for more depth */}
        {[20, 60, 110, 150].map((angle, i) => (
          <motion.line
            key={`line2-${angle}`}
            x1="500"
            y1="500"
            x2={500 + Math.cos(angle * Math.PI / 180) * 700}
            y2={500 + Math.sin(angle * Math.PI / 180) * 700}
            fill="none"
            custom={i + 8}
            variants={draw}
            strokeOpacity={0.02}
          />
        ))}
      </motion.svg>
    </div>
  );
};

export default NauticalDepthBackground;